import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WhitebuttonComponent} from './whitebutton.component';
import { WhitebuttonDirective } from './whitebutton.directive';



@NgModule({
  declarations: [WhitebuttonComponent, WhitebuttonDirective],
  imports: [
    CommonModule,

  ],
  exports:[
    WhitebuttonComponent, WhitebuttonDirective
  ]
})
export class WhitebuttonModule { }
